'use client'

import { useQuery } from '@tanstack/react-query'
import { useTranslations } from 'next-intl'

import Link from 'component/block/link'
import LoadingSpinner from 'component/block/loading/spinner'
import NoQueryResult from 'component/block/no-content/query-result'
import { fetchSearchHashtags } from 'server-actions/fetch-search'
import SearchItem from '../dropdown-card/search-item'
import numberFormat from 'util/numberFormat'

interface IHashtagResult {
  queryKeywords: string
}
const HashtagResult = ({ queryKeywords }: IHashtagResult) => {
  const t = useTranslations()
  const { data, isLoading } = useQuery({
    queryKey: ['searchResultHashtag', queryKeywords],
    queryFn: async () => {
      const hashtags = await fetchSearchHashtags(
        queryKeywords.startsWith('#') ? queryKeywords.slice(1) : queryKeywords
      )

      return hashtags
    }
  })

  const hashtagList = data || []

  if (isLoading) {
    return <LoadingSpinner />
  }

  if (hashtagList.length === 0) {
    return (
      <NoQueryResult className='m-auto max-w-[432px] py-[32px] text-center'>
        {t('search.no_result.keyword', {
          search_term: queryKeywords
        })}
      </NoQueryResult>
    )
  }

  return hashtagList.map((hashtag, index) => (
    <Link
      key={`search_hashtag_${index}`}
      href={`/hashtag/${hashtag.name}`}
      className='block px-[16px] py-[6px] hover:bg-background-2nd'
    >
      <SearchItem
        title={hashtag.name}
        prefix={
          <div
            className='i-ps-hashtag_s [--icon-size:24px]'
            role='img'
            aria-label='Hashtag'
          />
        }
        description={`${numberFormat(
          hashtag.counts.comment_count || 0,
          'compact'
        )} ${t('common.posts')}`}
      />
    </Link>
  ))
}

export default HashtagResult
